import { YammerState } from '../../state/types';

type GetIsDismissed = (state: YammerState) => boolean;
export const getIsDismissed: GetIsDismissed = (state) => !!state.browserDeprecation?.isDismissed;
